import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ChevronRightIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({ strokeWidth = 3, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-chevron-right">
    <path
      d="M20 12 L32 25 L20 38"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinejoin="miter"
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default ChevronRightIcon;
